import React, {Component} from 'react';
import InputValidationError from "../common/InputValidationError";

export default class ManualAddress extends Component {
    render() {
        const {onChange, info, toggleManualAddress, errors} = this.props;
        return (
            <section>
                <div className='container pb-5'>
                    <div className="row justify-content-center py-3">
                        <h2 className="wizard-heading">Enter address</h2>
                    </div>
                    <div className="row justify-content-center ">
                        <div className="col-md-10 justify-content-center">
                            <div className="card ">
                                <div className="card-body card-wizard">
                                    <div className="form-group row">
                                        <div className="col-md-3">
                                            <label className='wizard-label'>
                                                <small>Flat or property number <i
                                                    className='fa fa-asterisk'> </i></small>
                                            </label>
                                        </div>
                                        <div className="col-md-9">
                                            <input type="text" name='property_number'
                                                   className='form-control'
                                                   onChange={onChange}
                                                   value={info.property_number}
                                                   placeholder='Enter flat or property number...'/>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <div className="col-md-3">
                                            <label className='wizard-label'>
                                                <small>Street name <i className='fa fa-asterisk'> </i>
                                                </small>
                                            </label>
                                        </div>
                                        <div className="col-md-9">
                                            <input type="text" name='street_name' className='form-control'
                                                   onChange={onChange}
                                                   value={info.street_name}
                                                   placeholder='Enter street name...'/>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <div className="col-md-3">
                                            <label className='wizard-label'>
                                                <small>City <i className='fa fa-asterisk'> </i></small>
                                            </label>
                                        </div>
                                        <div className="col-md-9">
                                            <input type="text" name='city_name' className='form-control'
                                                   onChange={onChange}
                                                   value={info.city_name}
                                                   placeholder='Enter city name...'/>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <div className="col-md-3">
                                            <label className='wizard-label'>
                                                <small>Postcode <i className='fa fa-asterisk'> </i></small>
                                            </label>
                                        </div>
                                        <div className="col-md-9">
                                            <input type="text" name='postcode' className='form-control'
                                                   onChange={onChange}
                                                   value={info.postcode}
                                                   placeholder='Enter postcode...'/>
                                        </div>
                                    </div>
                                    <div className='pull-right row px-3'>
                                        <small className="text-danger">
                                            <a href="#" onClick={toggleManualAddress} style={{color: '#FDB913'}}>
                                                Find your address
                                            </a>
                                        </small>
                                    </div>
                                </div>
                            </div>
                            <InputValidationError error={errors.address}/>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}
